import { Box, Flex, Image, Text } from "@chakra-ui/react";

interface ResultRowProps {
  coverUrl?: string;
  title: string;
  subtitle: string;
  onClick: () => void;
}

export function ResultRow({
  coverUrl,
  title,
  subtitle,
  onClick,
}: ResultRowProps) {
  return (
    <Box>
      <Flex
        align="center"
        gap={4}
        py={1}
        cursor="pointer"
        _hover={{ bg: "transparent.white.10" }}
        onClick={onClick}
        borderRadius="4px"
      >
        {coverUrl && (
          <Image
            src={coverUrl}
            alt={title}
            w="42px"
            h="65px"
            objectFit="cover"
            borderRadius="2px"
            border="0.5px solid"
            borderColor="transparent.white.20"
            flexShrink={0}
          />
        )}
        <Flex direction="column" minW={0} flex={1}>
          <Text
            fontSize="14px"
            color="white"
            fontWeight="400"
            fontFamily="Roboto"
            lineHeight="1.3"
            noOfLines={1}
          >
            {title}
          </Text>
          <Text
            fontSize="12px"
            color="reader.neutral.400"
            fontFamily="Roboto"
            lineHeight="1.3"
            noOfLines={1}
          >
            {subtitle}
          </Text>
        </Flex>
      </Flex>
      <Box
        h="1px"
        bg="transparent.white.10"
        ml={coverUrl ? "58px" : "0"}
      />
    </Box>
  );
}
